/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_ScheduleInputs */

const en_messages_schedule = /** @type {(inputs: Messages_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule`)
};

const he_messages_schedule = /** @type {(inputs: Messages_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תזמון`)
};

/**
* | output |
* | --- |
* | "Schedule" |
*
* @param {Messages_ScheduleInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_schedule = /** @type {((inputs?: Messages_ScheduleInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_ScheduleInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_schedule(inputs)
	return he_messages_schedule(inputs)
});